module.exports = __webpack_public_path__ + "img/stock4.67961e29.png";